<template>
    <div>
        <img v-if="logo" :src="require(`@/assets/img/drs/${logo}.svg`)" />
        <div>
            <p
                v-text="location.name"
                class="text-md font-weight-medium mb-1"
            />
            <p
                v-if="location.address"
                v-text="address"
                class="text-xs mb-0"
            />
        </div>
    </div>
</template>

<script>
import locationMappingMixin from '@/components/drs/service/location-mapping.mixin'
import { LOGOS } from '@/utils/constants/drs/logos'

export default {
    mixins: [locationMappingMixin],

    props: {
        location: {
            type: Object,
            required: true
        },
        logo: {
            type: String,
            required: false,
            validator: value => Object.values(LOGOS).includes(value)
        }
    },

    computed: {
        address() {
            return this.formatAddress(this.location.address)
        }
    }
}
</script>